import { create } from "zustand";
import { api } from "../utils/api";
import type { RankingEntry, HeadToHeadResult } from "../types";

interface ComparisonState {
  rankings: RankingEntry[];
  headToHead: HeadToHeadResult | null;
  loading: boolean;

  fetchMasterRankings: (teamId: string, trackWeekId: string, sortBy?: string, eventTypes?: string) => Promise<void>;
  fetchHeadToHead: (runA: string, runB: string) => Promise<void>;
}

export const useComparisonStore = create<ComparisonState>((set) => ({
  rankings: [],
  headToHead: null,
  loading: false,

  fetchMasterRankings: async (teamId, trackWeekId, sortBy = "top10_avg", eventTypes?) => {
    set({ loading: true });
    try {
      let url = `/api/comparison/master?team_id=${teamId}&track_week_id=${trackWeekId}&sort_by=${sortBy}`;
      if (eventTypes) url += `&event_types=${encodeURIComponent(eventTypes)}`;
      const rankings = await api<RankingEntry[]>(url);
      set({ rankings, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  fetchHeadToHead: async (runA, runB) => {
    set({ loading: true });
    try {
      const result = await api<HeadToHeadResult>(
        `/api/comparison/head-to-head?run_a=${runA}&run_b=${runB}`
      );
      set({ headToHead: result, loading: false });
    } catch {
      set({ loading: false });
    }
  },
}));
